import auth0 from 'auth0-js';
import { createActions } from 'redux-actions';
import { call, put, select } from 'redux-saga/effects';
import { sendResetPasswordEmailAuth0 } from '../../../../remote-apis';
import { auth0ConfigSelector } from '../../configuration/selectors';

const actions = createActions({
  USER: {
    API: {
      SEND_RESET_PASSWORD_EMAIL: {
        REQUEST: undefined,
        SUCCESS: undefined,
        FAILED: (error) => ({ error })
      }
    },
    SEND_RESET_PASSWORD_EMAIL: (email) => ({ email })
  }
})

export function* sendResetPasswordEmail({
  payload: {
    email
  }
}) {
  const auth0Config = yield select(auth0ConfigSelector);
  const webAuth = new auth0.WebAuth({
    clientID: auth0Config.clientId,
    domain: auth0Config.domain
  });

  yield put(actions.user.api.sendResetPasswordEmail.request());

  const resetResponse = yield call(sendResetPasswordEmailAuth0, email, webAuth, auth0Config.realm);

  yield put(
    resetResponse.isSuccess ?
      actions.user.api.sendResetPasswordEmail.success() :
      actions.user.api.sendResetPasswordEmail.failed({
        description: resetResponse.error && resetResponse.error.description ?
          resetResponse.error.description :
          'Something wrong with reset password, please try again.'
      })
  )
}

const configuration = {
  name: 'sendResetPasswordEmail',
  action: actions,
  sagas: sendResetPasswordEmail,
  reducers: {
    request: (state, action) => ({
      ...state,
      error: null,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      error: null,
      isFetching: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isFetching: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/sendResetPasswordEmail.js